module.exports = __webpack_public_path__ + "img/lightbulb-dollar.7ac826bd.svg";